const Menu = () => {
  return (
    <div style={{backGroundColor: "#f2efeb"}} >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          color: "grey",
          fontFamily: 'Montserrat',
          backgroundColor: "#f2efeb"
        }}
      >
        <p>INFO</p>
        <p>RSVP</p>
        <p>SCHEDULE</p>
        <p>GUIDES</p>
        <p>FAQ</p>
      </div>
    </div>
  );
};

export default Menu;
